import log from '@/logger'

// This mixin automatically clears timeouts and intervals when components is destroyed
export default {
  data () {
    return {
      timeouts: [],
      intervals: []
    }
  },
  methods: {
    setTimeout (action, delay) {
      const timeout = window.setTimeout(action, delay)
      this.timeouts.push(timeout)
      return timeout
    },
    setInterval (action, interval) {
      const result = window.setInterval(action, interval)
      this.intervals.push(result)
      return result
    },
    clearTimeouts () {
      this.timeouts.forEach(window.clearTimeout)
    },
    clearIntervals () {
      this.intervals.forEach(window.clearInterval)
    }
  },
  beforeDestroy () {
    log.info('destroy-internals-and-timeouts', this.internals, this.timeouts)
    this.clearTimeouts()
    this.clearIntervals()
  }
}
